import { VISITOR_ID_MAX_LENGTH } from "./visitor-id-constants";

const CONTROL_CHARACTER_PATTERN = /[\u0000-\u001F\u007F]/;

/**
 * Validates a visitor id string against the following criteria:
 * - Must not be empty or whitespace-only
 * - Must not be longer than the maximum length
 * - Must not contain control characters
 */
function isValidVisitorId(value?: string): value is string {
  if (!value) {
    return false;
  }

  const trimmed = value.trim();

  if (!trimmed.length || trimmed?.length > VISITOR_ID_MAX_LENGTH) {
    return false;
  }

  return !CONTROL_CHARACTER_PATTERN.test(trimmed);
}

export { isValidVisitorId };
